import React from "react";

const AskIrisSectionBlk = () => {
  return (
    <React.Fragment>
      <div className="ask-iris-section-blk">
        <video autoPlay muted loop playsInline>
          <source
            src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/videos/video-background.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <div className="ask-iris-section-blk-overlay">
          <img
            className="iris-pattern-blk"
            src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/ask-iris-pattern.png"
            alt="Iris Pattern Background"
          />
          <img
            className="light-left-ask-iris-blk"
            src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/left-light-ask-iris.png"
            alt="Light Left Side"
          />
          <img
            src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/ask-iris-pattern-left.png"
            alt="Left Wand"
            className="left-pattern-ask-iris"
          />
          <img
            src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/ask-iris-pattern-right.png"
            alt="Right Wand"
            className="right-pattern-ask-iris"
          />
        </div>
        <div className="main-container-blk askiris-blk">
          <h1>Ask iRis</h1>
          <h2>iRis - your agentic CX AI Concierge</h2>
          <p>
            Your on-demand digital concierge, purpose-built for you to
            fast-track client first-calls, deliver bespoke value propositions
            and insights, and keep every client conversation ahead of the curve
            - from prospect scoping to technical guidance on AWS CX AI services
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AskIrisSectionBlk;
